import {
	ApiUtils,
	_axios
}from '@/api/apiUtil.js';
import constant from '@/util/constant.js';
const api = {
	list: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.getLoadingAjax(constant.serverUrl + "/sprint/sprintBacklog/list", params, successCallback, failCallback, exceptionCallback);
	},getOne: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.getLoadingAjax(constant.serverUrl + "/sprint/sprintBacklog/getOne", params, successCallback, failCallback, exceptionCallback);
	},
	save: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.postLoadingAjax(constant.serverUrl + "/sprint/sprintBacklog/save", params, successCallback, failCallback, exceptionCallback);
	},
	isSuperWorkingHours: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.postLoadingAjax(constant.serverUrl + "/sprint/sprintBacklog/isSuperWorkingHours", params, successCallback, failCallback, exceptionCallback);
	}
	,saveFrSurvey: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.postLoadingAjax(constant.serverUrl + "/sprint/sprintBacklog/saveFrSurvey", params, successCallback, failCallback, exceptionCallback);
	},
	toUpdate: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.getLoadingAjax(constant.serverUrl + "/sprint/sprintBacklog/toUpdate", params, successCallback, failCallback, exceptionCallback);
	},
	update: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.putLoadingAjax(constant.serverUrl + "/sprint/sprintBacklog/update", params, successCallback, failCallback, exceptionCallback);
	},
	remove: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.deleteLoadingAjax(constant.serverUrl + "/sprint/sprintBacklog/remove", params, successCallback, failCallback, exceptionCallback);
	},
	zhuanRang: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.postLoadingAjax(constant.serverUrl + "/sprint/sprintBacklog/zhuanRang", params, successCallback, failCallback, exceptionCallback);
	},
	getSBLByProId: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.getLoadingAjax(constant.serverUrl + "/product/sprint/getSprintsByProId", params, successCallback, failCallback, exceptionCallback);
	},
	selectPmid:(params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.getLoadingAjax(constant.serverUrl + "/sprint/sprintBacklog/selectPmid", params, successCallback, failCallback, exceptionCallback);
	},
	
	getMeetingsBySprint: (params, successCallback, failCallback, exceptionCallback) => {
    ApiUtils.getLoadingAjax(constant.serverUrl + "/sprint/meeting/listBySprint", params, successCallback, failCallback, exceptionCallback);
}
}

export default api;
